import { type RefObject, useEffect } from 'react';

const useTransformLinksToExternal = (refs: RefObject<HTMLElement | null>[]) => {
  useEffect(() => {
    refs.forEach(ref => {
      const el = ref.current;

      if (el) {
        el.querySelectorAll('a').forEach(a => {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        });
      }
    });
  });
};

export default useTransformLinksToExternal;
